import app from "@ooo-inex/cms-app";
import '@ooo-inex/cms-app/dist/assets/style.css'; // попадает в cms-wrap/dist/assets/index.css

app.mount("#cms-app-root");
